import * as LabelPrimitive from '@radix-ui/react-label'
import { forwardRef, type ComponentRef, type ComponentPropsWithoutRef } from 'react'

import { cn } from '@/lib/utils'

export const Label = forwardRef<
  ComponentRef<typeof LabelPrimitive.Root>,
  ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn('peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className)}
      {...props}
    />
  )
})
Label.displayName = LabelPrimitive.Root.displayName
